import React from "react";
import ReactDOM from "react-dom";
import AdminApp from "./AdminApp";

ReactDOM.render(<AdminApp />, document.getElementById("root"));
